import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';
import styled from 'styled-components';

import { useI18n } from '../../hooks';
import { defaultThemeProp } from '../../theme';
import type { NoChildrenProp, RefElement, WithAttributes } from '../../types';
import NoValue from '../NoValue/NoValue';

export type BooleanDisplayProps = WithAttributes<
  'span',
  NoChildrenProp & {
    /** Boolean value */ value?: boolean;
    /** The text to be displayed when value is true.
     * @default 'Yes'
     */
    trueLabel?: string;
    /** The text to be displayed when value is false.
     * @default 'No'
     */
    falseLabel?: string;
  }
>;

const StyledBooleanDisplay = styled.span``;

StyledBooleanDisplay.defaultProps = defaultThemeProp;

export default forwardRef<RefElement<BooleanDisplayProps>, PropsWithoutRef<BooleanDisplayProps>>(
  function BooleanDisplay({ value, trueLabel, falseLabel, ...restProps }, ref) {
    const t = useI18n();

    const displayText = value
      ? trueLabel || t('boolean_display_true_label')
      : falseLabel || t('boolean_display_false_label');

    return (
      <StyledBooleanDisplay ref={ref} {...restProps}>
        {value !== undefined ? displayText : <NoValue />}
      </StyledBooleanDisplay>
    );
  }
);
